import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { translate } from "../../../i18n";
import { TimeWindowDto } from "../../../models/time-window/dto/time-window.dto";
import { GET_TIME_WINDOW_GROUPS_QUERY_KEY } from "./useGetTimeWindowGroups";
import { GET_TIME_WINDOWS_QUERY_KEY } from "./useGetTimeWindows";

export type BatchUpsertTimeWindowsDto = Array<{
    startTime: Date;
    endTime: Date;
}>;

export const useBatchUpsertTimeWindows = (groupId: string, onSuccess?: (data: TimeWindowDto[]) => void) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();

    return useMutation({
        mutationKey: ['batchUpsertTimeWindows', groupId],
        mutationFn: (dto: BatchUpsertTimeWindowsDto) =>
            client.fetchApi<TimeWindowDto[], BatchUpsertTimeWindowsDto>({
                endpoint: `time-windows/groups/${groupId}/windows`,
                method: 'PUT',
                body: dto
            }),
        onSuccess: (data) => {
            // Invalidate both the group list and the specific group's windows
            queryClient.invalidateQueries({ queryKey: GET_TIME_WINDOW_GROUPS_QUERY_KEY() });
            queryClient.invalidateQueries({ queryKey: GET_TIME_WINDOWS_QUERY_KEY(groupId) });
            onSuccess?.(data);
        },
        onError: () => {
            toast({ title: translate('time_windows.save_error'), status: 'error' });
        }
    });
};